export default "__VITE_ASSET__DG2a4AMn__"